import { useRef } from 'react';
import './OrderItems.css';
import { ApiOrderItem } from '../../types';
import { Link } from 'react-router-dom';
import { useFormatting } from '../../i18n/i18n';
import { useTranslation } from '../../i18n/i18n';
import { Img } from '../Img/Img';
import { useConfig } from '../../config';
import { Icon, not_in_stock, check_circle } from '../../components/Icon/Icon';

type OrderItemsProps = {
	orderItems: ApiOrderItem[];
};
export const OrderItems = ({ orderItems }: OrderItemsProps): JSX.Element => {
	return (
		<div className="order-item-wrapper">
			{orderItems.map((orderItem) => (
				<OrderItem key={orderItem.id} orderItem={orderItem} />
			))}
		</div>
	);
};

const OrderItem = ({ orderItem }: { orderItem: ApiOrderItem }): JSX.Element => {
	const { asPrice } = useFormatting();
	const imgRef = useRef<HTMLImageElement>(null);
	const { currency, currencyCode } = useConfig();

	const { stocked, stock, quantity, product } = orderItem;

	const t = {
		...useTranslation().product,
		...useTranslation().orderPages,
	};

	return (
		<div className="row">
			<div className="product-image">
				<Img ref={imgRef} src={orderItem.image} width={50} height={50} alt={product.name} />
			</div>
			<div className="product-details-wrapper">
				<div className="product-link">
					<Link to={'/-p-' + product.id}>{product.name}</Link>
				</div>
				<div className="article-number">
					<dl>
						<dt>{t.articleNumber}:</dt>
						<dd>{product.displayId}</dd>
					</dl>
				</div>
				<div className="stocked">
					<dl>
						<dt>{t.inStockVerbatim}:</dt>
						<dd>
							<span>
								{stocked && stock > 0 ? (
									<Icon shape={check_circle}></Icon>
								) : (
									<Icon shape={not_in_stock}></Icon>
								)}
							</span>
						</dd>
					</dl>
				</div>
				<div className="vat">
					<dl>
						<dt>{t.vat}:</dt>
						<dd>{product.tax}%</dd>
					</dl>
				</div>
				<div className="quantity">
					<dl>
						<dt>{t.amount}:</dt>
						<dd>{quantity}</dd>
					</dl>
				</div>
				<div className="price">
					<dl>
						<dt>{t.price}:</dt>
						<dd>
							<strong>
								{asPrice(product.finalPrice, 2, true, false)}
								{currencyCode !== 'EUR' && <span className="unit"> {currency}</span>}
							</strong>
						</dd>
					</dl>
				</div>
				<div className="total">
					<dl>
						<dt>{t.total}:</dt>
						<dd>
							<strong>
								{asPrice(quantity * product.finalPrice, 2, true, false)}
								{currencyCode !== 'EUR' && <span className="unit"> {currency}</span>}
							</strong>
						</dd>
					</dl>
				</div>
			</div>
		</div>
	);
};
